import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FloatingSwitchComponent } from './shared/floating-switch/floating-switch.component';
import { ApiUrl } from '../shared/models/apiurl.models';
import { AppService } from './services/app.service';
@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, FloatingSwitchComponent]
})
export class AppComponent {
  constructor(private translate: TranslateService, private apiUrl: ApiUrl, private appService: AppService) {
    this.translate.setDefaultLang('he'); // default
    this.appService.getAppInfo().subscribe((res: any)=>{
      this.appService.appInfo = res["results"][0];
    })
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
    document.dir = lang === ('ar' || 'he') ? 'rtl' : 'ltr';
  }
}
